import { useCustomerFundingNeedsRetrieveSuspense } from "@boundless/bl-api-client/customer/services"
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { useStore } from "zustand/react"

import { ApplicationFlowContext } from "@/lib/flows/application"
import { store } from "@/lib/store"

export const Route = createFileRoute(
  "/_dashboard/_application-flow/funding-requests/$fundingNeedsUuid",
)({
  component: RouteComponent,
  beforeLoad: ({ context: { hasPermissions } }) => {
    if (!hasPermissions(["applications.view_fundingneeds"])) {
      throw redirect({ to: "/" })
    }
  },
})

function RouteComponent() {
  const activeCompanyUuid = useStore(store, (state) => state.activeCompanyUuid)
  if (!activeCompanyUuid) {
    throw redirect({ to: "/" })
  }

  const applicationFlow = ApplicationFlowContext.useActorRef()
  const { fundingNeedsUuid } = Route.useParams()
  const { data: fundingNeeds } = useCustomerFundingNeedsRetrieveSuspense(
    activeCompanyUuid,
    fundingNeedsUuid,
  )

  applicationFlow.send({
    type: "setFundingNeeds",
    fundingNeeds,
  })

  return <Outlet />
}
